import http from '../../../http/base';
import { API_PATHS } from '../../../http/configs';
import { replaceRouteParams } from '../../../utilities/routeHelper';

export const getFile = (filePartitionKey, fileRowKey) => http.get(replaceRouteParams(API_PATHS.getFile, filePartitionKey, fileRowKey));